import AttachmentDataProviderItem from 'owa-service/lib/contract/AttachmentDataProviderItem';
import AttachmentDataProviderItemType from 'owa-service/lib/contract/AttachmentDataProviderItemType';
import AttachmentThumbnailInfo from 'owa-service/lib/contract/AttachmentThumbnailInfo';
import FileProviderItemViewState, {
    FileItemViewState,
    FolderItemViewState,
    FileProviderItemType,
    GroupCategory,
    GroupItemViewState,
    ImageInfo,
    ImageLoadState,
} from '../store/schema/FileProviderItemViewState';
import { numberToByteQuantifiedStringConverter } from 'owa-file';
import GroupAttachmentDataProviderItem from 'owa-service/lib/contract/GroupAttachmentDataProviderItem';
import { userDate } from 'owa-datetime';

function getSizeDisplayString(sizeInBytes: number) {
    return sizeInBytes !== 0 ? numberToByteQuantifiedStringConverter(sizeInBytes) : '';
}

function getThumbnail(thumbnailInfo: AttachmentThumbnailInfo): ImageInfo {
    return thumbnailInfo && thumbnailInfo.Url
        ? {
              url: thumbnailInfo.Url,
              width: thumbnailInfo.Width || 200,
              height: thumbnailInfo.Height || 200,
              loadState: ImageLoadState.NotLoaded,
          }
        : null;
}

function createFileProviderItemViewState(
    item: AttachmentDataProviderItem
): FileProviderItemViewState {
    if (item.Type == AttachmentDataProviderItemType.File) {
        const fileItem: FileItemViewState = {
            type: FileProviderItemType.File,
            key: item.Id,
            name: item.Name,
            location: item.Location,
            modifiedTime: item.Modified ? userDate(item.Modified) : null,
            modifiedBy: item.ModifiedBy,
            sharedBy: item.SharedBy,
            sharedTime: item.SharedTime ? userDate(item.SharedTime) : null,
            sizeDisplayString: item.Size ? getSizeDisplayString(item.Size) : '',
            from: item.From,
            subject: item.Subject,
            receivedDate: item.ReceivedDate ? userDate(item.ReceivedDate) : null,
            model: item,
            thumbnail: getThumbnail(item.Thumbnail),
        };

        return fileItem;
    } else if (item.Type == AttachmentDataProviderItemType.Folder) {
        const folderItem: FolderItemViewState = {
            type: FileProviderItemType.Folder,
            key: item.Id,
            name: item.Name,
            location: item.Location,
            modifiedTime: item.Modified ? userDate(item.Modified) : null,
            modifiedBy: item.ModifiedBy,
            sharedBy: item.SharedBy,
            sharedTime: item.SharedTime ? userDate(item.SharedTime) : null,
            childCount: item.ChildCount,
            from: item.From,
            subject: item.Subject,
            receivedDate: item.ReceivedDate ? userDate(item.ReceivedDate) : null,
            model: item,
            thumbnail: getThumbnail(item.Thumbnail),
        };

        return folderItem;
    } else if (item.Type == AttachmentDataProviderItemType.Group) {
        const groupItem = item as GroupAttachmentDataProviderItem;
        const groupItemViewState: GroupItemViewState = {
            type: FileProviderItemType.Group,
            key: groupItem.Id,
            name: groupItem.Name,
            location: groupItem.Location,
            modifiedTime: groupItem.Modified ? userDate(groupItem.Modified) : null,
            modifiedBy: groupItem.ModifiedBy,
            sharedBy: groupItem.SharedBy,
            sharedTime: groupItem.SharedTime ? userDate(groupItem.SharedTime) : null,
            from: groupItem.From,
            subject: groupItem.Subject,
            receivedDate: groupItem.ReceivedDate ? userDate(groupItem.ReceivedDate) : null,
            model: groupItem,
            thumbnail: getThumbnail(groupItem.Thumbnail),
            pagingMetadata: groupItem.PagingMetadata,
            joinDate: groupItem.JoinDate ? userDate(groupItem.JoinDate) : null,
            groupCategory: getGroupCategory(groupItem),
        };
        return groupItemViewState;
    }

    throw new Error('Unknown AttachmentDataProviderItem type: ' + item.__type);
}

function getGroupCategory(item: GroupAttachmentDataProviderItem) {
    switch (item.GroupCategory) {
        case 'Favorite groups':
            return GroupCategory.Favorite;
        case 'Joined groups':
            return GroupCategory.Joined;
        default:
            return GroupCategory.Other;
    }
}

export default function createFileProviderItemsViewState(
    items: AttachmentDataProviderItem[]
): FileProviderItemViewState[] {
    return items.map(createFileProviderItemViewState);
}
